import React from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';

const EmailModal = (props) => {
  const { email, onClose } = props;

  if (!email) {
    return null;
  }
  return (
    <Modal show={!!email} size="lg" onHide={onClose}>
      <Modal.Body>
        <Row>
          <Col className="font-weight-bold">{email.from}</Col>
        </Row>
        <Row>
          <Col>{email.subject}</Col>
        </Row>
        <Row>
          <Col className="col-1">To:</Col>
          <Col className="text-muted">{email.to}</Col>
        </Row>
        {email.cc &&
          <Row>
            <Col className="col-1">CC:</Col>
            <Col className="text-muted">{email.cc}</Col>
          </Row>
        }
        <Row className="mt-2">
          <Col>
            <textarea disabled>{email.body}</textarea>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailModal;
